import moment from 'moment-timezone'

// The browser's zone abbreviation is more specific than members expect to
// see (EST vs EDT depending on the date) — collapse both to the single label
// used everywhere else on the site.
export default (): string => {
  const zone = moment.tz(moment.tz.guess()).zoneAbbr()

  if (/E(S|D)T/.test(zone)) return 'ET'
  if (/P(S|D)T/.test(zone)) return 'PT'

  return zone
}
